export default __webpack_public_path__ + "static/media/not-speed.d31e9be5.svg";